export default {
  state: {
    show: false,
    message: ''
  },
  mutations: {
    TOAST(state, payload) {
      payload.show = payload.show === undefined ? true : payload.show
      Object.assign(state, {}, payload)
      //console.log(state)
    }
  },
  actions: {
    toast(store, payload) {
      store.commit('TOAST', payload)
    }
  }
}
